import type { SheetGeometry, SheetSVGGeometry, SheetTextGeometry } from "building-types/views/sheetGeometryTypes";
import type { TableCellStyle } from "./nodeStylesTypes";

export enum TableCellContentType {
  TEXT = "text",
  SVG = "svg",
  GROUP = "group",
}

// Table cell content types for props
export type TextCellContents = Omit<SheetTextGeometry, "x" | "y" | "text" | "layerId"> &
  Partial<Pick<SheetTextGeometry, "x" | "y">> & { text?: string | number };

export type SVGCellContents = Omit<SheetSVGGeometry, "x" | "y" | "layerId" | "inPlanScale" | "scale"> &
  Partial<Pick<SheetSVGGeometry, "x" | "y">>;

export type GroupCellContents = {
  children: SheetGeometry[];
};

// Table cell props interfaces
export interface TableCellPropsBase {
  cellStyle?: TableCellStyle;
}

export interface GroupTableCellProps extends TableCellPropsBase {
  contentType: TableCellContentType.GROUP;
  contents: GroupCellContents;
}

export interface SVGTableCellProps extends TableCellPropsBase {
  contentType: TableCellContentType.SVG;
  contents: SVGCellContents;
}

export interface TextTableCellProps extends TableCellPropsBase {
  contentType: TableCellContentType.TEXT;
  contents: TextCellContents;
}

export type TableCellProps = GroupTableCellProps | SVGTableCellProps | TextTableCellProps;
